<template>
    <p class="mb-1 text-base leading-7 text-gray-600 dark:text-gray-300">
        <span v-safe-html="text"></span>
        <Tooltip
            v-if="hasTooltip"
            text="This is an estimate for your planning purposes. Consult with your issuer for the exact date."
            placement="left"
        />
    </p>
</template>
<script>
import Tooltip from "@/components/tooltip.vue";

export default {
    name: "ExclusionText",
    props: {
        text: {
            type: String,
            default: "",
        },
        hasTooltip: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Tooltip,
    },
    data: () => ({}),
};
</script>
